var mapStyles = [{
    featureType: "water",
    elementType: "geometry",
    stylers: [{color: "#e9e9e9"}, {lightness: 17}]
}, {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{color: "#eeeeee"}, {lightness: 20}]
}, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{color: "#ffffff"}, {lightness: 17}]
}, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{color: "#ffffff"}, {lightness: 29}, {weight: .2}]
}, {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{color: "#ffffff"}, {lightness: 18}]
}, {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{color: "#ffffff"}, {lightness: 16}]
}, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{color: "#f5f5f5"}, {lightness: 21}]
}, {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{color: "#dedede"}, {lightness: 21}]
}, {
    elementType: "labels.text.stroke",
    stylers: [{visibility: "on"}, {color: "#ffffff"}, {lightness: 16}]
}, {
    elementType: "labels.text.fill",
    stylers: [{saturation: 36}, {color: "#333333"}, {lightness: 40}]
}, {elementType: "labels.icon", stylers: [{visibility: "off"}]}, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{color: "#f2f2f2"}, {lightness: 19}]
}, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{color: "#fefefe"}, {lightness: 20}]
}, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{color: "#fefefe"}, {lightness: 17}, {weight: 1.2}]
}];

;(function ($) {
    var pluginName = 'twnMap';
    var defaults = {
        apikey: "AIzaSyCsRw0s8ocTkkiOOUCrfvpUiEY5AaTNaCU",
        zoom: 17,
        maxZoom: 17,
        centerLat: 58.3826557,
        centerLong: 26.7179671,
        marker: "/assets/svg/map-marker.svg"
    };

    var initSelector = '.js-map';


    function Map(element, options) {
        this.$map = $(element);
        this.options = $.extend({}, defaults, options, this.$map.data());
        this._defaults = defaults;
        this._name = pluginName;
        this.markers = [];
        this.mapLinks = this.$map.parents(".map").find('[data-maplink]');

        this.init();
    }

    Map.prototype.init = function () {
        this.addressLoaded = false;

        this.coordinatesByAddress(this.options.address);
        this.setMaplinks(this.options.address);

        var _that = this;
        GoogleMapsLoader.KEY = this.options.apikey;
        GoogleMapsLoader.load(function (google) {
            _that.google = google;

            _that.map = new google.maps.Map(_that.$map[0], {
                zoom: _that.options.zoom,
                maxZoom: _that.options.maxZoom,
                center: new google.maps.LatLng(_that.options.centerLat, _that.options.centerLong),
                mapTypeControl: !1,
                styles: mapStyles,
                disableDefaultUI: !0
            });

            google.maps.event.addListenerOnce(_that.map, 'idle', function(){
                console.log($('iframe').removeAttr('tabindex').removeAttr('aria-hidden').attr('aria-label', 'Map'))
            });

            _that.loadPoints();
        });

    };

    Map.prototype.loadPoints = function () {
        var _that = this;
        if (this.addressCoordinates ) {
            // oota aadressi kordinaadid
            this.addPoint(this.addressCoordinates.lat, this.addressCoordinates.lng, this.options.marker );

        } else if (this.options.mapicons) {
            var mapIcons = this.options.mapicons.replace(/\t+/g, "").replace(/(\r\n|\n|\r)/gm, "").replace(/ +?/g, '').split(";");
            for (var i in mapIcons) {
                if (mapIcons[i] == "") {
                    continue;
                }
                var values = mapIcons[i].split(",");
                var lat = parseFloat(values[0]);
                var lng = parseFloat(values[1]);
                var icon = values[2] || this.options.mzr;
                this.addPoint(lat, lng, icon );
            }
        } else {
            console.log("No pint data");
            this.coordinatesByAddress(this.options.address, true);
            return;
        }

        this.fitBounds();
    };

    Map.prototype.addPoint = function (lat, lng, icon) {
        position = new this.google.maps.LatLng(lat, lng);

        marker = new this.google.maps.Marker({
            position: position,
            icon: {
                url: icon,
                scaledSize: new this.google.maps.Size(50, 50)
            },
            optimized: false,
            map: this.map
        });

        this.markers.push(marker);
    };

    Map.prototype.coordinatesByAddress = function (address, autoLoad) {
        var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + encodeURIComponent(address) + "&key=" + this.options.apikey;
        var _that = this;

        $.getJSON(url, function (data) {
            if (data.results.length > 0) {
                _that.addressCoordinates = data.results[0].geometry.location;
                if(autoLoad){
                    _that.loadPoints();
                }
            }
        });
    };

    Map.prototype.fitBounds = function () {
        var bounds = new this.google.maps.LatLngBounds();

        for (var i in this.markers) {
            bounds.extend(this.markers[i].position);
        }

        this.map.fitBounds(bounds);
    };

    Map.prototype.setMaplinks = function(address) {
        if(!this.mapLinks){
            return;
        }

        var linkUrl = "https://www.google.com/maps/search/?api=1&query="+ encodeURIComponent(address);
        this.mapLinks.attr('href',linkUrl);
    };

    /**
     * Destroy the plugin instance
     * @method destroy
     * @returns {void}
     */
    Map.prototype.destroy = function () {
        $(this.$map[0]).removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @listens rkas.map
     * @returns {Array<Map>} Array of Maps
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Map(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @event enhance.twn.map
     * @param   {Event} event
     */
    $(document).on('enhance.twn.map', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.twn.map
     * @param   {Event} event
     */
    $(document).on('destroy.twn.map', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.twn.map
     */
    $(function () {
        $(document).trigger('enhance.twn.map');
    });
}(jQuery));
